<template>
  <div class="user-list">
    <SearchBar v-bind="searchBar"/>
    <Table v-bind="table" class="page-table" hiddenOperate height="400">
      <template slot="isQingteng" slot-scope="{scope}">
        {{ scope.isQingteng?' 青腾用户':'普通会员' }}
      </template>
      <template slot="isJoin" slot-scope="{scope}">
        <el-checkbox v-model="scope.isJoin" :true-label="1" :false-label="0">参与线下活动</el-checkbox>
      </template>
    </Table>
  </div>
</template>

<script>
import Table from '@/components/page/Table.vue'
import SearchBar from '@/components/page/SearchBar.vue'
import { getSignUpUsers, addJoinUsers } from '@/api/activity'
const initParams = {
  nickName: '',
  phone: '',
  isJoin: ''
}

export default {
  components: {
    Table,
    SearchBar
  },
  props: {
    activityId: Number
  },
  data () {
    return {
      params: { ...initParams },
      searchBar: {
        list: [{
          type: 'input',
          prop: 'nickName',
          label: 'ID/会员姓名',
          placeholder: '请输入ID/会员姓名'
        }, {
          type: 'input',
          prop: 'phone',
          label: '会员电话',
          placeholder: '请输入会员电话'
        }, {
          type: 'select',
          prop: 'isJoin',
          label: '是否参与线下活动',
          // valueKey: '',
          // labelKey: '',
          options: [{
            value: '',
            label: '全部'
          }, {
            value: 1,
            label: '参加'
          }, {
            value: 0,
            label: '未参加'
          }],
          placeholder: '请选择活动状态'
        }, {
          type: 'btn',
          text: '搜索',
          btnType: 'primary',
          callback: (params) => {
            this.params = { ...this.params, ...params }
            this.initData()
          }
        }, {
          type: 'btn',
          text: '重置',
          btnType: 'primary',
          isReset: true,
          callback: this.resetList
        }]
      },
      table: {
        selection: false, // 是否开启选择框
        index: true,
        // disableKey: 'xxx', // 是否可勾选字段
        tableInfo: [{
          key: 'userId',
          name: '会员ID',
          minWidth: 80
        }, {
          key: 'nickName',
          name: '会员姓名',
          minWidth: 80
        }, {
          key: 'phone',
          name: '会员电话',
          minWidth: 80
        }, {
          key: 'isQingteng',
          name: '会员等级',
          type: 'custom',
          minWidth: 80
        }, {
          key: 'isJoin',
          name: '是否参加线下活动',
          type: 'custom',
          minWidth: 80
        }],
        tableData: [],
        deleteList: (list) => {
          console.log(list)
        }
      }
    }
  },
  mounted () {
    this.initData()
  },
  watch: {
    activityId () {
      this.initData()
    }
  },
  methods: {
    async save () {
      const ids = this.table.tableData.map(t => {
        if (t.isJoin) return t.userId
      })
      await addJoinUsers({
        joinUserIds: ids,
        activityId: this.activityId
      })
      this.$emit('update:isShowPage', false)
    },
    async initData () {
      const params = {...this.params, activityId: this.activityId}
      const {data} = await getSignUpUsers(params)
      this.$set(this.table, 'tableData', data)
    },
    resetList () {
      this.params = { ...initParams }
      this.initData()
    }
  }
}
</script>

<style lang="scss" scoped>
  .user-list {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
</style>